module.exports = __webpack_public_path__ + "fonts/ABCMonumentGrotesk-Medium.2fb673f.woff";